import { Injectable } from '@angular/core';
import { DifficultyLevel, QuizSubject } from '../interfaces/question.interface';
import { ScoreRecord } from '../interfaces/score.interface';
import { getDailyBonusTopic } from '../data/league-config';

@Injectable({ providedIn: 'root' })
export class ScoringService {

  private readonly BASE_XP: Record<DifficultyLevel, number> = {
    [DifficultyLevel.EASY]: 10,
    [DifficultyLevel.MEDIUM]: 20,
    [DifficultyLevel.HARD]: 35
  };

  getStreakMultiplier(streak: number): number {
    if (streak < 2) return 1.0;
    if (streak < 5) return 1.25;
    if (streak < 10) return 1.5;
    if (streak < 20) return 2.0;
    return 2.5;
  }

  getDailyBonusMultiplier(questionSubject: QuizSubject): number {
    const dailyBonus = getDailyBonusTopic();
    return questionSubject === dailyBonus.subject ? dailyBonus.multiplier : 1.0;
  }

  getSpeedBonus(timeRemaining: number, timeLimit: number): number {
    const ratio = timeRemaining / timeLimit;
    if (ratio > 0.75) return 5;
    if (ratio > 0.5) return 3;
    if (ratio > 0.25) return 1;
    return 0;
  }

  calculateXP(params: {
    difficulty: DifficultyLevel;
    streak: number;
    questionSubject: QuizSubject;
    timeRemaining: number;
    timeLimit: number;
    isCorrect: boolean;
  }): ScoreRecord {
    if (!params.isCorrect) {
      return { baseXP: 0, streakMultiplier: 1, dailyBonusMultiplier: 1, speedBonus: 0, totalXP: 0 };
    }

    const baseXP = this.BASE_XP[params.difficulty];
    const streakMultiplier = this.getStreakMultiplier(params.streak);
    const dailyBonusMultiplier = this.getDailyBonusMultiplier(params.questionSubject);
    const speedBonus = this.getSpeedBonus(params.timeRemaining, params.timeLimit);
    const totalXP = Math.round((baseXP * streakMultiplier * dailyBonusMultiplier) + speedBonus);

    return { baseXP, streakMultiplier, dailyBonusMultiplier, speedBonus, totalXP };
  }
}
